import React, { Component } from "react";
import DraggerIcon from "../icons/draggericon";
import CatEditIcon from "../icons/catediticon";
import TextField from "../component/TextField";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
//Validation import
import SimpleReactValidator from "simple-react-validator";

//Service import
import service from "../services";
import Loader from "../component/loader";
import Tablist from "./Tablist";

let sub;

class AwardCategory extends Component {
  constructor(props) {
    super(props);

    this.state = {
      addCatmodal: false,
      imagePreloader: false,
      getAllCategoryDetails: [],
      getAllCategoryDocs: [],
      name: "",
      changeCategoryTitleName: false,
      id: "",
      loaderFlag: false,
      isDraggable: false,
      eventiveId:'',
      isEdited: false
    };
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.apiserve = new service();
    this.tablistRef = React.createRef();
  }

  CloseModal = () => {
    this.setState({
      changeCategoryTitleName:false,
      addCatmodal: false,
      id:'',
      name: "",
      eventiveId:'',
      isEdited: false
    });
    this.validator.hideMessages();
  };

  componentDidMount = async () => {
    this.getAllCategory();
    this.getcategory();
    this.setState({
      loaderFlag: true,
    });
  };

  componentWillUnmount = () => {
    sub.unsubscribe();
  };

  onInputChange = (e) => {
    this.updateState({
      [e.target.name]: e.target.value,
    });
  };

  updateState = (data, callback) => {
    this.setState({
      ...data,
      isEdited: true
    }, callback);
  }

  getcategory = () => {
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "film|awardCategory|getList":
          this.setState(
            {
              getAllCategoryDetails: response.data,
              getAllCategoryDocs: response.data.docs,
              error: response.data.error,
            },
            () => {
              this.setState({
                loaderFlag: false,
              });
              if (this.tablistRef.current) this.tablistRef.current.updatedAt();
            }
          );
          break;
        case "film|awardCategory|update":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error,
            });
          } else {
          this.setState(
            {
              addCatmodal: false,
              changeCategoryTitleName:false,
            },
            this.setState({ loaderFlag: false }),
            this.apiserve.success("Catagory updated successful.")
          );
          }
          this.getAllCategory();
          break;
          case "film|awardCategory|changeOrder":
          break;
      }
    });
  };

  getAllCategory = () => {
    this.apiserve.sendevent("film|awardCategory|getList", {});
  };

  submitFn = async (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      this.setState({ loaderFlag: true });
      if (this.state.changeCategoryTitleName) {
        let updateCategory = {
          name: this.state.name,
          awardCategoryId: this.state.id,
          eventiveId:this.state.eventiveId, 
        };
        this.apiserve.sendevent("film|awardCategory|update", updateCategory);
      } 
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  editCategoryUser = async (item) => {
    this.setState({
      addCatmodal: true,
      changeCategoryTitleName: true,
      name: item.name,
      id: item._id,
      eventiveId:item.eventiveId ? item.eventiveId : '',
      isEdited: false
    });
    this.validator.hideMessages("")
  };

  onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const { destination, source } = result;
    const oldIndex = source.index;
    const newIndex = destination.index;
    const arr = [...this.state.getAllCategoryDocs];
    if (newIndex >= arr.length) {
      var k = newIndex - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
    const updateArr = [];
    arr.forEach(({ _id }, i) => {
      updateArr.push({
        awardCategoryId: _id,
        sortIndex: i + 1,
      });
    });
    this.setState({ isDraggable: true });
    const data = { order: updateArr };
    this.apiserve.sendevent("film|awardCategory|changeOrder", data);
    this.setState({ getAllCategoryDocs: arr });
  };

  validateModel = () => {
    this.setState({
      errorMsg: false,
    });
  };
  render() {
    const { getAllCategoryDocs, changeCategoryTitleName } = this.state;
    return (
      <React.Fragment>
          <div className="right_side_wrapper">
            <Tablist active='Film' name="awardCategory" ref={this.tablistRef} />
            <div className="cat_outer_content">
              <div className="category_add_edit category_column">
                <div className="category_header relative d_flex">
                  <p>Films Award Category</p>
                  <p>Display Name</p>
                </div>
                <div className="list_wrap striped_droppable_table">
                  <DragDropContext onDragEnd={this.onDragEnd}>
                    <Droppable droppableId="droppable">
                      {(provided, snapshot) => (
                        <ul
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                        >
                          {getAllCategoryDocs.map((item, index) => (
                            <Draggable
                              key={item._id}
                              draggableId={item._id}
                              index={index}
                            >
                              {(provided, snapshot) => (
                                <li
                                  className="pointer d_flex d_flex_align_center"
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  <span className="cat_drag d_flex">
                                    <DraggerIcon />
                                  </span>
                                  <div className="cat_name d_flex">
                                    <p className="">{item.name}</p>
                                    <p className="display_name">{item.displayName}</p>
                                  </div>
                                  <div className="action d_flex d_flex_align_center">
                                    <span
                                      className="cat_edit pointer"
                                      onClick={() =>
                                        this.editCategoryUser(item)
                                      }
                                    >
                                      <CatEditIcon />
                                    </span>
                                  </div>
                                </li>
                              )}
                            </Draggable>
                          ))}
                        </ul>
                      )}
                    </Droppable>
                  </DragDropContext>
                </div>
              </div>
            </div>
            <div
              className={`user_popup ${this.state.addCatmodal ? "active" : ""}`}
            >
              <span className="popup_overlay" onClick={this.CloseModal}></span>
              <div className="cat_modal_inner">
                <p className="cat_title text_center">
                  {changeCategoryTitleName
                    ? "Edit Award Category"
                    : "Award Category"}
                </p>
                <form>
                  <div className="field_row horizontal_field d_flex">
                    <TextField
                      type="text"
                      label="Category Name"
                      name="name"
                      value={this.state.name}
                      disable={true}
                    />
                  </div>
                  { 
                  <div className="field_row horizontal_field d_flex">
                    <TextField
                      type="text"
                      label="Eventive ID"
                      name="eventiveId"
                      value={this.state.eventiveId}
                      onChange={this.onInputChange}
                      fpgerror={this.validator.message(
                        "Eventive ID",
                        this.state.eventiveId,
                        "required"
                      )}
                    />
                  </div>}
                  <div className="cat_btns text_center">
                    <button type="button" onClick={this.CloseModal}>
                      CANCEL
                    </button>
                    <button
                      className={this.state.changeCategoryTitleName && !this.state.isEdited ? "disabled" : "active"}
                      disabled={this.state.changeCategoryTitleName && !this.state.isEdited}
                      onClick={(e) => this.submitFn(e)}
                    >
                      SAVE
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        <div className={`user_popup ${this.state.errorMsg ? "active" : ""}`}>
          <span className="popup_overlay"></span>
          <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
            <div className="approve_popup_header text_center relative">
              <p>{this.state.errorMsgShow}</p>
            </div>
            <div className="content">
              <div className="field_row text_center">
                <button
                  className="small_btn active"
                  onClick={this.validateModel}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
        {this.state.loaderFlag ? <Loader /> : ""}
      </React.Fragment>
    );
  }
}

export default AwardCategory;
